import React      from 'react';
import ReactDOM from 'react-dom';
import CSSModules from 'react-css-modules';
import classnames from 'classnames/bind';

import TransparentButton from '../TransparentButton';

import style from './style.scss';
import navigator from '../../services/navigator';
import MaterialIcon from './../MaterialIcon';
import { generatePlatformLinks } from '../../services/navigationLinkGenerator';

const container = document.getElementById('content');

class HeaderNavigation extends React.Component {

    constructor() {
        super();

        this.state = {
            isMobileMenuOpen: false
        };

        this._handleDocumentClick = this._handleDocumentClick.bind(this);
    }

    componentDidMount() {
        container.addEventListener('click', this._handleDocumentClick);
    }

    componentWillUnmount() {
        container.removeEventListener('click', this._handleDocumentClick);
    }

    _getMenuIconClassNames() {
        const cx = classnames.bind(style);

        return cx({
            'menu-icon': true,
            'menu-icon--active': this.state.isMobileMenuOpen
        });
    }

    _getSlideoutNavClassNames() {
        const cx = classnames.bind(style);

        return cx({
            'slideout-nav': true,
            'slideout-nav--open': this.state.isMobileMenuOpen
        });
    }

    _getSlideoutNavLinkClassNames(isActive) {
        const cx = classnames.bind(style);

        return cx({
            'slideout-nav__link': true,
            'slideout-nav__link--active': isActive
        });
    }

    _getNavigationClasses() {

        var classes = style['navigation'];

        if (this.props.showMobileMenu) {

            classes += ' ' + style['navigation--show'];
        }

        return classes;
    }

    _handleDocumentClick(evt) {
        const area = ReactDOM.findDOMNode(this);

        if (!area.contains(evt.target) && this.state.isMobileMenuOpen) {
            this._toggleSlideOutNavigation();
        }
    }

    _toggleSlideOutNavigation() {
        // Scroll to the top of page so menu aligns with header
        //document.body.scrollTop = document.documentElement.scrollTop = 0;

        // Prevent user from scrolling when menu is open
        document.body.style.overflow = this.state.isMobileMenuOpen ? 'auto' : 'hidden';

        this.setState({
            isMobileMenuOpen: !this.state.isMobileMenuOpen
        });
    }

    _navigateToMobileLink(url, event) {
        event.preventDefault();
        navigator.push(url);
        this._toggleSlideOutNavigation();
    }

    navigate(navigateTo, event) {
        event.preventDefault();
        navigator.push(navigateTo);
    }

    render() {

        const navButtonStyle = this.props.scrollHeader ? 'scroll-nav-button' : 'nav-button';
        return (
            <div>
            <nav className={ this._getNavigationClasses() }>
                <ul className={style['nav-list']}>

                    <li className={style['nav-item']}>

                        <a href="" className={style[navButtonStyle]} onClick={this.navigate.bind(this, '/')}>
                            Home
                        </a>

                    </li>

                    <li className={style['nav-item']}>

                        <a href="" className={style[navButtonStyle]} onClick={this.navigate.bind(this, '/events')}>
                            Programme
                        </a>

                    </li>

                    <li className={style['nav-item']}>

                        <a href="" className={style[navButtonStyle]} onClick={this.navigate.bind(this, '/courses')}>
                            Courses
                        </a>

                    </li>

                    <li className={style['nav-item']}>

                        <a href="" className={style[navButtonStyle]} onClick={this.navigate.bind(this, '/e-learning')}>
                            e-Learning
                        </a>

                    </li>

                    <li className={style['nav-item']}>

                        <a href="" className={style[navButtonStyle]} onClick={this.navigate.bind(this, '/conferences')}>
                            Conferences
                        </a>

                    </li>

                    <li className={style['nav-item']}>

                        <a className={style[navButtonStyle]} href="http://www.rheglobal.com/contact">
                            Contact
                        </a>

                    </li>

                </ul>
                <img className={style['logo']} src="/assets/images/rhe_logo_white.png" />
                    <TransparentButton
                        className={this._getMenuIconClassNames()}
                        aria-pressed={this.state.isMobileMenuOpen}
                        aria-label="Show the platform navigation menu"
                        onClick={this._toggleSlideOutNavigation.bind(this)}
                    >
                        <img src="/assets/images/1901_icon_hamburger_white.png" />
                    </TransparentButton>

                <nav
                    aria-hidden={!this.state.isMobileMenuOpen}
                    aria-label="Mobile main navigation menu"
                    className={this._getSlideoutNavClassNames()}
                >
                    <ul className={style['slideout-nav__link-list']}>
                        {generatePlatformLinks().map((link, i) => {
                            if (!link.show) return null;

                            return (
                                <li key={i} className={style['slideout-nav__item']}>
                                    <a
                                        href={link.label === 'Contact' ? link.url : ``}
                                        tabIndex={this.state.isMobileMenuOpen ? 0 : -1}
                                        className={this._getSlideoutNavLinkClassNames(link.isActive)}
                                        onClick={link.label !== 'Contact' ? this._navigateToMobileLink.bind(this, link.url) : null}
                                    >
                                        {link.label}
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </nav>

            </nav>
            </div>
        );
    }
}

export default CSSModules(HeaderNavigation, style);


// WEBPACK FOOTER //
// ./components/HeaderNavigation/index.js